export default "__VITE_ASSET__BdnFw97a__"